import { useRouter } from 'next/router';

/**
 * Validates a token by making an API call to the backend.
 * #login
 * @param {string} apiURL - the URL of the API to validate the token
 * @param {string} token - the token to validate
 * @returns {Promise<boolean>} - a promise that resolves with a boolean indicating whether the token is valid or not
 */
export const validateToken = async (apiUrl, token) => {

  try {
    if (!token) {
      return false;
    }
    // Make API call to backend to validate token
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      console.error('Token validation response not ok');
      return false;
    }

    const data = await response.json();
    return data.valid;
  } catch (error) {
    console.error('Token validation error:', error);
    return false;
  }
};

/**
 * Hook that checks if a user is authenticated by validating their token.
 * #unused
 * If the token is invalid, it removes the token from local storage and redirects the user to the login page.
 * @returns {Promise<boolean>} - a promise that resolves with a boolean indicating whether the user is authenticated or not
 */
export const useAuthCheck = () => {
  const router = useRouter();

  const checkAuth = async () => {
    const token = typeof window !== 'undefined' ? localStorage.getItem('token') : undefined;
    
    if (!await validateToken(token)) {
      if (typeof window !== 'undefined') {
        localStorage.removeItem('token');
      }
      
      router.push('/login');
      return false;
    }
    
    return true;
  };

  return checkAuth;
};
